/**
 * Created by emanuele on 31/01/2017.
 */
import React from 'react';
import { Progress } from 'semantic-ui-react'

const AttivitaProgressGroup = ({ percCompletamento, attivitaNonCompletate, numAttivita }) => {

    let title = "Attività registrate: " + numAttivita;
    if (attivitaNonCompletate){
        title += "; Ci sono attività ancora da completare."
    }
    if (percCompletamento > 0)
    {
        return <Progress active={attivitaNonCompletate} color={attivitaNonCompletate ? 'red' : 'blue'} percent={percCompletamento} title={title}/>
    }
    else {
        return <Progress disabled={true} value={0} total={100} title={title}/>
    }

}

export default AttivitaProgressGroup;


/** WEBPACK FOOTER **
 ** ./src/components/attivita/AttivitaProgressGroup.jsx
 **/